var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1479_21452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5918 0H7.5918C3.44966 0 0.0917969 3.35786 0.0917969 7.5V42.5C0.0917969 46.6421 3.44966 50 7.5918 50H42.5918C46.7339 50 50.0918 46.6421 50.0918 42.5V7.5C50.0918 3.35786 46.7339 0 42.5918 0Z",
    fill: "#CC6699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2871 8.59369C15.9121 11.8163 9.85742 18.3593 10.4434 22.2656C11.0293 26.1718 16.8887 29.2968 19.5254 31.3476C16.1074 33.1054 11.8105 35.7421 11.9082 39.1601C12.1035 43.8476 17.1816 42.3827 19.3301 41.0156C21.4785 39.6484 23.627 35.8398 22.2598 31.8359C25.2871 31.0546 27.9238 32.0312 28.7051 32.6171C31.7324 34.7656 30.1699 37.207 29.0957 37.5976C28.0215 37.9882 28.7051 38.1835 29.3887 37.9882C30.0723 37.7929 31.5371 36.8163 31.5371 35.1562C31.5371 30.957 27.0449 29.0038 21.4785 30.4687C18.2559 27.0507 13.8613 25.4882 14.0566 21.7773C14.1543 20.4101 14.6426 16.8945 23.334 12.4999C32.0254 8.1054 38.1777 9.86322 37.3965 13.8671C36.2246 19.9218 25.6777 24.0234 21.9668 20.5077C21.7715 20.1171 21.0879 19.8242 21.4785 20.8984C23.4316 25.7812 39.252 23.5351 39.9355 13.1835C40.1309 7.71478 32.2207 6.24994 25.2871 8.59369ZM16.8887 39.8437C14.4473 40.6249 14.5449 39.0624 14.6426 38.4765C14.9355 36.8163 16.3027 34.7656 20.4043 32.7148C21.5762 36.4257 18.9395 39.2577 16.8887 39.8437Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1479_21452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.0917969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSass);
export default __webpack_public_path__ + "static/media/sass.cde0503fc9459e307f6653da731cbd95.svg";
export { ForwardRef as ReactComponent };